<div class="flex flex-column p-4">
    <!-- Form Content -->
    <div class="pr-2 pb-4">
        <form *ngIf="form" [formGroup]="form" (ngSubmit)="save()" id="techConfigForm" #documentEditForm="ngForm" class="flex flex-column gap-4 mt-3">
            
            <!-- Code Field -->
            <div class="flex flex-column gap-2">
                <p-floatLabel variant="on">
                    <input pInputText id="code" formControlName="code" autocomplete="off" class="w-full" />
                    <label for="code">Código</label>
                </p-floatLabel>
                <small *ngIf="showCodePatternHint" class="text-secondary ml-1">Solo números</small>
                <small *ngIf="form.controls.code.invalid && form.controls.code.touched" class="p-error">
                    {{getErrorMessage(form.controls.code)}}
                </small>
            </div>

            <!-- Value Field -->
            <div class="flex flex-column gap-2">
                <p-floatLabel variant="on">
                    <input *ngIf="!textAreaValue.includes(currentModel)" pInputText id="value" formControlName="value" autocomplete="off" class="w-full" />
                    <textarea *ngIf="textAreaValue.includes(currentModel)" pTextarea id="value" formControlName="value" [autoResize]="true" class="w-full" rows="3"></textarea>
                    <label for="value">Valor</label>
                </p-floatLabel>
                <small *ngIf="form.controls.value.invalid && form.controls.value.touched" class="p-error">
                    {{getErrorMessage(form.controls.value)}}
                </small>
            </div>

            <!-- Translation Field -->
            <div *ngIf="showTranslation().includes(currentModel)" class="flex flex-column gap-2">
                <p-floatLabel variant="on">
                    <textarea pTextarea id="translation" formControlName="translation" [autoResize]="true" class="w-full" rows="3"></textarea>
                    <label for="translation">Traducción</label>
                </p-floatLabel>
                <small *ngIf="form.controls.translation.invalid && form.controls.translation.touched" class="p-error">
                    {{getErrorMessage(form.controls.translation)}}
                </small>
            </div>

            <!-- Abbreviation Field -->
            <div *ngIf="currentModel == 'sectors' || currentModel == 'docTypes'" class="flex flex-column gap-2">
                <p-floatLabel variant="on">
                    <input pInputText id="abbreviation" formControlName="abbreviation" autocomplete="off" class="w-full" />
                    <label for="abbreviation">Abreviatura</label>
                </p-floatLabel>
            </div>

            <!-- Branch Field (Sectors) -->
            <div *ngIf="currentModel == 'sectors' && !nestedMode" class="flex flex-column gap-2">
                <p-floatLabel variant="on">
                    <p-select id="branchId" [options]="branches" formControlName="branchId" 
                             optionValue="id" optionLabel="name" [showClear]="true" [filter]="true" filterBy="name"
                             placeholder="Seleccione Sucursal" styleClass="w-full" class="w-full">
                    </p-select>
                    <label for="branchId">Sucursal</label>
                </p-floatLabel>
            </div>
            
            <!-- Revision Period Field (docTypes) -->
            <div *ngIf="currentModel == 'docTypes'" class="flex flex-column gap-2">
                <p-floatLabel variant="on">
                    <p-inputNumber id="revisionPeriod" formControlName="revisionPeriod" class="w-full" [showButtons]="true" [min]="1" [max]="10" suffix=" años"></p-inputNumber>
                    <label for="revisionPeriod">Periodo de revisión</label>
                </p-floatLabel>
            </div>

            <!-- Kind Field (Matrix) -->
            <div *ngIf="currentModel == 'matrix' && checkShowControl('tech_config', 'kind')" class="flex flex-column gap-2">
                <p-floatLabel variant="on">
                    <p-select id="kind" [options]="typeValue | keyvalue" formControlName="kind" 
                             optionValue="value" optionLabel="value" [showClear]="true" 
                             placeholder="No determinado" class="w-full">
                    </p-select>
                    <label for="kind">Tipo</label>
                </p-floatLabel>
            </div>

            <!-- Classification Field (Matrix) -->
            <div *ngIf="currentModel == 'matrix' && checkShowControl('tech_config', 'classification')" class="flex flex-column gap-2">
                <p-floatLabel variant="on">
                    <p-select id="classification" [options]="classification" formControlName="classification" 
                             class="w-full">
                        <ng-template pTemplate="selectedItem" let-selectedOption>
                            {{MatrixClassificationMap.get(selectedOption)}}
                        </ng-template>
                        <ng-template pTemplate="item" let-option>
                            {{MatrixClassificationMap.get(option)}}
                        </ng-template>
                    </p-select>
                    <label for="classification">Clasificación</label>
                </p-floatLabel>
            </div>

            @if (currentModel == 'matrix') {
                <!-- Grupos de Ensayo (Matrix) -->
                <div class="flex flex-column gap-2">
                    <p-floatLabel variant="on">
                        <p-multiSelect id="assayGroupIds" [options]="assayGroupsList" formControlName="assayGroupIds" 
                                optionValue="id" optionLabel="name" 
                                class="w-full"
                                [maxSelectedLabels]="3"
                                appendTo="body">
                        </p-multiSelect>
                        <label for="assayGroupIds">Grupos de Ensayos</label>
                    </p-floatLabel>
                </div>

                <!-- Grupos Peligros / Control Samples (Matrix) -->
                @if (showSampleControl) {
                    <div class="flex flex-column gap-2">
                        <p-floatLabel variant="on">
                            <p-multiSelect id="sampleControlGroupIds" [options]="sampleControlGroupsList" formControlName="sampleControlGroupIds" 
                                    optionValue="id" optionLabel="name" 
                                    class="w-full"
                                    [maxSelectedLabels]="3"
                                    appendTo="body">
                            </p-multiSelect>
                            <label for="sampleControlGroupIds">{{ sampleControlLabel }}</label>
                        </p-floatLabel>
                    </div>
                }
            }

            <!-- Toggles Section -->
            <div class="flex flex-column gap-3 mt-2">
                <!-- Criteria (Sectors) -->
                <div *ngIf="currentModel == 'sectors' && checkShowControl('tech_config', 'sectors')" class="flex align-items-center justify-content-between p-2 surface-50 border-round">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-list text-primary"></i>
                        <span class="font-medium">Incluir criterios en etiquetas</span>
                    </div>
                    <p-toggleswitch formControlName="criteria"></p-toggleswitch>
                </div>

                <!-- Hold (Matrix) -->
                <div *ngIf="currentModel == 'matrix' && checkShowControl('tech_config', 'hold')" class="flex align-items-center justify-content-between p-2 surface-50 border-round">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-lock text-primary"></i>
                        <span class="font-medium">Retención</span>
                    </div>
                    <p-toggleswitch formControlName="hold"></p-toggleswitch>
                </div>

                <!-- Web Access (Doctors) -->
                <div *ngIf="currentModel == 'doctors'" class="flex align-items-center justify-content-between p-2 surface-50 border-round">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-globe text-primary"></i>
                        <span class="font-medium">Acceso Web</span>
                    </div>
                    <p-toggleswitch formControlName="webActive"></p-toggleswitch>
                </div>

                <!-- Active -->
                <div class="flex align-items-center justify-content-between p-2 surface-50 border-round">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-check-circle text-primary"></i>
                        <span class="font-medium">Activo</span>
                    </div>
                    <p-toggleswitch formControlName="active"></p-toggleswitch>
                </div>
            </div>
        </form>
    </div>

    <!-- Footer Actions -->
    <div class="flex-shrink-0 flex justify-content-end gap-2 pt-3 border-top-1 surface-border bg-white sticky z-5" style="bottom: 0;">
        <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary" (onClick)="closeDialog()"></p-button>
        <p-button label="Guardar" icon="pi pi-save" (onClick)="save()" [disabled]="deshabilitarBotonGuardar()" [loading]="isSaving"></p-button>
    </div>
</div>
